<div>
  <section class="form-tasklist">

    <div style="margin: 0px 12px 12px 12px;">
      <ebb-portal-ebb-inspection-form
        [application]="application"
        (emitInspectionInfoChangeEvent)="onEmitInspectionFormChangeEvent($event)">
      </ebb-portal-ebb-inspection-form>
    </div>

    <div style="margin: 28px 12px 12px 12px;">
      <ebb-portal-inspection-file-list
        [application]="application"
        (emitInspectionFileChangeEvent)="onEmitInspectionFileChangeEvent($event)">
      </ebb-portal-inspection-file-list>
    </div>

  </section>

  <div style="margin: 32px 12px 12px 12px;">
    <p style="font-size: 14px;">
      Once you have provided the date of the inspection and uploaded all of the files related to the inspection, please submit the completed documentation.
    </p>
    <button mat-flat-button color="primary"
      [disabled]="(!completedInspectionForm || !completedInspectionFile) || this.submittedInspection"
      (click)="onClickSubmitInspectionDocumentation()">
      SUBMIT INSPECTION DOCUMENTATION
    </button>
  </div>

  <div *ngIf="formSavingProgress" style="margin-top: 12px; margin-left: 12px;">
    <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
  </div>

  <div *ngIf="!waitForFilesToShow && waitForFilesToSort else displayLoadingDocumentation"
    style="margin: 32px 12px 12px 12px;">
    <button mat-stroked-button color="primary"
      (click)="toggleShowHidePhotos()">
      {{labelShowHidePhotos}}
    </button>
  </div>
  <ng-template #displayLoadingDocumentation>
    <p style="margin: 32px 12px 12px 12px; font-size: 14px;">
      Loading project documentation...
    </p>
  </ng-template>

  <div *ngIf="showHidePhotos"
    style="margin-top: 24px; margin-left: 12px;">

    <h6>
      Permit Documents
    </h6>
    <mat-divider></mat-divider>

    <mat-list class="file-list"
      [ngStyle]="{'width': '90%'}"
      ngStyle.lt-lg="{'width': '100%'}"
      ngStyle.lt-md="{'margin-top': '28px', 'margin-bottom': '28x'}">
      <mat-list-item
        *ngFor="let file of permitFilesToShow">
        <div matLine
          style="display: inline-block !important; width: 100%;"
          ngStyle.gt-sm="{'margin-bottom': '12px'}"
          ngStyle.lt-md="{'margin-bottom': '36px'}">
          <div fxLayout="row" fxLayout.lt-md="column wrap"
            ngStyle.gt-sm="{'margin-top': '9px'}">
            <div fxFlex='80%'>
              <div style="font-size: 16px; font-weight: 400;">
                {{file.fileName}}
              </div>
              <a style="color: #29637C; font-size: 16px; font-weight: 400;" [title]="file.payLoadName"
                  href="javascript:void(0)" (click)="onViewFileEvent(file.fileId)">
                  {{file.payLoadName | Filename}}
              </a>
            </div>

            <div fxFlex='20%'>
              <button mat-raised-button color="primary"
                style="text-transform: uppercase;"
                ngStyle.gt-sm="{'margin-top': '6px'}"
                (click)="onViewFileEvent(file.fileId)">
                VIEW
              </button>
            </div>
          </div>
<mat-divider fxShow ></mat-divider>
        </div>
      </mat-list-item>
    </mat-list>

    <div *ngIf="formDownloadProgress" style="margin-top: 12px; margin-left: 12px;">
      <mat-progress-bar mode="indeterminate" style="width: 300px;"></mat-progress-bar>
    </div>

    <h6 style="margin-top: 32px;">
      Project Photos
    </h6>
    <mat-divider></mat-divider>

    <p style="margin-top: 12px;">
      Pre-Retrofit
    </p>
    <div
      fxLayout="row wrap"
      fxLayout.xs="column wrap"
      fxLayoutAlign="start start">
      <mat-card *ngFor="let photo of preRetrofitPhotosToShow"
        fxFlex.gt-xs="50%"
        fxFlex.gt-md="30%"
        style="margin-top: 3px; margin-right: 3px;"
        [class.mat-elevation-z7]='true'>

        <mat-card-title style="font-size: 16px; font-weight: 400;">
          {{photo.fileName}}
        </mat-card-title>

        <div *ngIf="!waitForFilesToShow && waitForFilesToSort"
          style="margin-top: 6px; height: 200px; width: 100%; background-color: #f6f6f6; border:#29637C; border-width: 1px; border-style: solid;">
          <a href="javascript:void(0)" (click)="onViewPhotoEvent(photo)">
            <img *ngIf="lookupSubmittedPhoto(photo.fileId).fileShow"
              src={{lookupSubmittedPhoto(photo.fileId).file}}
              style="max-height:190px; max-width: 200px; display: block; margin: auto;"
              alt="Uploaded Image Asset"/>
          </a>
        </div>
        <div *ngIf="waitForFilesToShow" style="margin-top: 12px;">
          <mat-progress-bar mode="indeterminate" style="width: 100%;"></mat-progress-bar>
        </div>

        <mat-card-actions>
          <button mat-stroked-button color="primary"
            style="margin-left: 6px;"
            (click)="onViewPhotoEvent(photo)">
            ENLARGE PHOTO
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <p style="margin-top: 18px;">
      Post-Retrofit
    </p>
    <div
      fxLayout="row wrap"
      fxLayout.xs="column wrap"
      fxLayoutAlign="start start">
      <mat-card *ngFor="let photo of postRetrofitPhotosToShow"
        fxFlex.gt-xs="50%"
        fxFlex.gt-md="30%"
        style="margin-top: 3px; margin-right: 3px;"
        [class.mat-elevation-z7]='true'>

        <mat-card-title style="font-size: 16px; font-weight: 400;">
          {{photo.fileName}}
        </mat-card-title>

        <div *ngIf="!waitForFilesToShow && waitForFilesToSort"
          style="margin-top: 6px; height: 200px; width: 100%; background-color: #f6f6f6; border:#29637C; border-width: 1px; border-style: solid;">
          <a href="javascript:void(0)" (click)="onViewPhotoEvent(photo)">
            <img *ngIf="lookupSubmittedPhoto(photo.fileId).fileShow"
              src={{lookupSubmittedPhoto(photo.fileId).file}}
              style="max-height:190px; max-width: 200px; display: block; margin: auto;"
              alt="Uploaded Image Asset"/>
          </a>
        </div>
        <div *ngIf="waitForFilesToShow" style="margin-top: 12px;">
          <mat-progress-bar mode="indeterminate" style="width: 100%;"></mat-progress-bar>
        </div>

        <mat-card-actions>
          <button mat-stroked-button color="primary"
            style="margin-left: 6px;"
            (click)="onViewPhotoEvent(photo)">
            ENLARGE PHOTO
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <div style="margin-top: 24px;">
      <button mat-stroked-button color="primary"
        (click)="toggleShowHidePhotos()">
        {{labelShowHidePhotos}}
      </button>
    </div>
  </div>
</div>
